import { ValueSetViewModel } from './value-set.viewmodel';

export class ValueSetScopeViewModel {
  constructor(public scope: string, public valueSets: ValueSetViewModel[]) { }
}
